import React from 'react';
import useCoinshiftHelper from '../../helpers/coinshiftHelper';
import { useGlobalState } from '../../state/GlobalStateProvider';
import EmailPanel from '../login/EmailPanel';
import { useModal } from '../modal/ModalContext';
import './UserStats.scss';

const UserStats = () => {
  const [{ user }] = useGlobalState();
  const [userStats] = useCoinshiftHelper();
  const [{ openModal }] = useModal();

  const handleEmailModal = () => {
    openModal({ content: <EmailPanel /> });
  };

  const redirect = () => {
    window.open('https://coinshift.global/login', '_blank');
  };

  if (!user?.coinshiftEmail)
    return (
      <div className='attach_email_container'>
        <h3>Connect Coinshift Email to your Mercle account</h3>
        <button className='coinshift_button' onClick={handleEmailModal}>
          Connect Email
        </button>
        <p>
          Don`t have account ? Create a Coinshift account{' '}
          <a href='https://coinshift.global/login' target='_blank'>
            here
          </a>
        </p>
      </div>
    );
  if (!userStats)
    return (
      <div className='attach_email_container'>
        <h3>
          Create Coinshift account using <strong>{user?.coinshiftEmail}</strong> to continue{' '}
        </h3>
        <button onClick={redirect}>Create Coinshift Account</button>
      </div>
    );

  return (
    <div className='attach_email_container coinshift_eligible'>
      <div>
        <h2>
          Mercle <span>Exclusive</span>
        </h2>
        <p>
          With your base benefits of being a part of the program, all info{' '}
          <a href='https://coinshift-personal.gitbook.io/coinshift-personal/tiger-points-season-1' target='_blank'>
            [here]
          </a>
          , being a Mercle user you can get added amount of hefty rewards.
        </p>
      </div>
      <div>
        <h3>Hands of Support holders[ANY ONE]</h3>
        <p>This bonus is given only to users who have NFTs in their connected wallet at the time of verifying first deposit action on Mercle.</p>
        <br />
        <table>
          <tr>
            <th>NFT Holding</th>
            <th>Reward (TIGER)</th>
          </tr>
          <tr>
            <td>Diamond hands NFT</td>
            <td>300,000 TIGER</td>
          </tr>
          <tr>
            <td>Gold hands NFT</td>
            <td>120,000 TIGER</td>
          </tr>
          <tr>
            <td>Silver hands NFT</td>
            <td>50,000 TIGER</td>
          </tr>
        </table>
        {/* <p>Diamond hands NFT holder - 300K TIGER</p>
        <p>Gold hands NFT holder - 120K TIGER</p>
        <p>Silver hands NFT holder - 50K TIGER</p> */}
        <br />
      </div>
      <div>
        <h3>First Deposit Bonus [ANY ONE]</h3>
        <p>The bonus will be given only on your first deposit on Coinshift Personal account, after you've minted the Mercle NFT.</p>
        <br />
        <table>
          <tr>
            <th>Deposit Amount</th>
            <th>Reward (TIGER)</th>
          </tr>
          <tr>
            <td>$300 - $1,000</td>
            <td>50,000 TIGER</td>
          </tr>
          <tr>
            <td>$1,000 - $3,000</td>
            <td>120,000 TIGER</td>
          </tr>
          <tr>
            <td>$3,000+</td>
            <td>300,000 TIGER</td>
          </tr>
        </table>
        {/* <p>$300-$1000 USDC initial deposit - 50K TIGER</p>

        <p>$1000 - $3000 USDC initial deposit - 120K TIGER</p>

        <p>≥ $10000 USDC initial deposit - 300K TIGER</p> */}
      </div>
    </div>
  );
};

export default UserStats;
